import React from 'react';
import HOT from '../../assets/images/Hotesse2.png';
import { motion } from 'framer-motion';
import AZD from '../../assets/images/perso.png';
import EQP from '../../assets/images/equipement.jpg';
import INTE from '../../assets/images/inter.jpg';
import PERS from '../../assets/images/Persona.png';
import CONF from '../../assets/images/conf.png';
import { Link } from 'react-router-dom';

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.3,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
};

const imageVariants = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: { opacity: 1, scale: 1, transition: { duration: 0.6, ease: 'easeOut' } },
  hover: { scale: 1.05 },
};

const ServiceSection = () => {
  return (
    <motion.section
      id="ts-service-area"
      className="ts-service-area pb-0 position-relative"
      style={{
        backgroundImage: 'url(images/assets/ban4.jpg)',
       
        backgroundSize: 'cover',
        backgroundAttachment: 'fixed',
        backgroundPosition: 'center',
        overflow: 'hidden',
      }}
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, ease: 'easeOut' }}
    >
      {/* Overlay sombre */}
      <div
        className="overlay"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        
          zIndex: 1,
        }}
      />

      {/* Contenu principal */}
      <div className="container position-relative" style={{ zIndex: 2 }}>
        <div className="row text-center">
    
          <div className="col-12">
            <h3 className="section-sub-title text-dark">POURQUOI CHOISIR GEKAS ?</h3>
          </div>
        </div>

        <motion.div
          className="row"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {/* Left column */}
          <div className="col-lg-4 col-12 mb-4 mb-lg-0">
            {[
              { to: '/', title: 'Équipes', desc: 'Personnel hautement entraîné.', imgs:AZD },
              { to: '/', title: 'Équipements Professionnels', desc: 'Équipement moderne et performant.', imgs:EQP },
              { to: '/', title: 'Interventions', desc: 'Intervention rapide et efficace',  imgs:INTE },
            ].map((service, index) => (
              <motion.div
                key={index}
                className="ts-service-box d-flex mb-4"
                variants={itemVariants}
                whileHover={{ scale: 1.02, boxShadow: '0 8px 20px rgba(0,0,0,0.15)' }}
              >
                <div className="ts-service-box-img">
                  <img loading="lazy" src={service.imgs} style={{ width: '80px' }} alt="icon" />
                </div>
                <div className="ts-service-box-info ms-3">
                  <h3>
                    <Link to={service.to} className="text-decoration-none text-dark">
                      <b>{service.title}</b>
                    </Link>
                  </h3>
                  <p style={{ fontSize: '22px', fontFamily: 'Arial' }}>{service.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>

          {/* Center image */}
          <motion.div
            className="col-lg-4 col-12 text-center mb-4 mb-lg-0"
            initial="hidden"
            whileInView="visible"
            whileHover="hover"
            variants={imageVariants}
            viewport={{ once: true }}
          >
            <img loading="lazy" style={{ height: '100%', width: '100%' }} className="img-fluid" src={HOT} alt="service-avatar" />
          </motion.div>

          {/* Right column */}
          <div className="col-lg-4 col-12">
            {[
              { to: '/', title: 'Personnalisations', desc: 'Approche personnalisée pour chaque client.' , imgs:PERS},
              { to: '/', title: 'Confidentialités', desc: 'Respect strict de la confidentialité et de la loi.' ,  imgs:CONF},
              
            ].map((service, index) => (
              <motion.div
                key={index}
                className="ts-service-box d-flex mb-4"
                variants={itemVariants}
                whileHover={{ scale: 1.02, boxShadow: '0 8px 20px rgba(0,0,0,0.15)' }}
              >
                <div className="ts-service-box-img">
                  <img loading="lazy" src={service.imgs} style={{ width: '80px' }} alt="icon" />
                </div>
                <div className="ts-service-box-info ms-3">
                  <h3>
                    <Link to={service.to} className="text-decoration-none text-dark">
                      <b>{service.title}</b>
                    </Link>
                  </h3>
                  <p style={{ fontSize: '22px', fontFamily: 'Arial' }}>{service.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </motion.section>
  );
};

export default ServiceSection;
